import gql from 'graphql-tag'

export const updateCommentorVotes = gql`
  mutation UpdateBlogByType(
    $blogId: String!
    $batchData: BlogBatchDataInput!
    $type: String!
    $patientId: ID!
  ) {
    updateBlogByType(
      blogId: $blogId
      batchData: $batchData
      type: $type
      patientId: $patientId
    )
  }
`

export const updateVideoAnalysis = gql`
  mutation UpdateVideoAnalysis(
    $_id: String!
    $blogId: String!
    $patientId: String!
    $startTime: Float!
    $endTime: Float!
    $duration: Float!
  ) {
    updateVideoAnalysis(
      _id: $_id
      blogId: $blogId
      patientId: $patientId
      startTime: $startTime
      endTime: $endTime
      duration: $duration
    )
  }
`

export const updateVideoItem = gql`
  mutation updateVideoItem(
    $blogId: String
    $patientId: String
    $type: String
    $duration: Float
    $process: Float
    $sourceType: String
  ) {
    updateVideoItem(
      blogId: $blogId
      patientId: $patientId
      type: $type
      duration: $duration
      process: $process
      sourceType: $sourceType
    )
  }
`

export const updateBlogVote = gql`
  mutation UpdateBlogVote(
    $blogId: String!
    $systemType: String!
    $type: String!
    $patientId: ID!
    $commentId: String
  ) {
    updateBlogVote(
      blogId: $blogId
      systemType: $systemType
      type: $type
      patientId: $patientId
      commentId: $commentId
    )
  }
`

export const insertBlogComment = gql`
  mutation InsertBlogComment(
    $blogId: String!
    $commentId: String
    $beReplyedCommentId: String
    $beReplyedUserId: String
    $content: String
    $patientId: String!
    $commentType: String
    $systemType: String
    $replyTools: String
    $imgBase64: String
    $commentToBottle: Boolean
  ) {
    insertBlogComment(
      blogId: $blogId
      commentId: $commentId
      beReplyedCommentId: $beReplyedCommentId
      beReplyedUserId: $beReplyedUserId
      content: $content
      patientId: $patientId
      commentType: $commentType
      systemType: $systemType
      replyTools: $replyTools
      imgBase64: $imgBase64
      commentToBottle: $commentToBottle
    ) {
      sensitiveWords
      commitComment
    }
  }
`

export const insertView = gql`
  mutation InsertView(
    $blogId: String!
    $systemType: String!
    $patientId: ID
    $source: String
  ) {
    insertView(
      blogId: $blogId
      systemType: $systemType
      patientId: $patientId
      source: $source
    )
  }
`
// export const updateView = gql `
//   mutation UpdateView($id: String!) {
//     updateView(id: $id)
//   }
// `
export const updateArticleHelpState = gql`
  mutation UpdateArticleHelpState(
    $articleId: String!
    $patientId: String!
    $helpState: String!
  ) {
    updateArticleHelpState(
      articleId: $articleId
      patientId: $patientId
      helpState: $helpState
    )
  }
`

// updateBlogByType(   blogId: ID!   batchData: BlogBatchDataInput!   type:
// String!   patientId: ID! ): Boolean

export const cancelBlogComment = gql`
  mutation CancelBlogComment($blogId: String!, $patientId: ID!) {
    cancelBlogComment(blogId: $blogId, patientId: $patientId)
  }
`
export const getAppVision = gql`
  query getUserAppVision($patientId: ID!) {
    getUserAppVision(patientId: $patientId) {
      showImage
      isTourist
      appVersion
    }
  }
`
export const patientQueryById = gql`
  query patient($patientId: ID!) {
    patient(patientId: $patientId) {
      _id
      nickname
      petname
      username
      gender
      patientState
      healthCareTeamId
      commentToBottle
    }
  }
`

export const mutationSaveFollow = gql`
  mutation saveFollow1($selfId: String, $blogId: String, $status: Boolean) {
    saveFollow(selfId: $selfId, blogId: $blogId, status: $status)
  }
`



// WEBPACK FOOTER //
// ./src/modules/knowledge/actions/mutation.js